/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Sasank M",
  title: "Hi all, I'm Sasank",
  subTitle: emoji(
    "A Software Developer & Cloud Engineer ☁️ passionate about building scalable apps, CI/CD pipelines & AI-powered solutions using Python / Java / JavaScript. Actively seeking 2025 job opportunities to create impactful tech with cloud & AI! 🚀"  ),
  resumeLink:
    "https://smaraba-personal-bucket.s3.amazonaws.com/Sasank_Resume_Combined.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/smarabattula",
  linkedin: "https://www.linkedin.com/in/smarabattula/",
  gmail: "smarabattula@gmail.com",
  // gitlab: "https://gitlab.com/smarabattula",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "DEVELOPER OF WEB, CLOUD, ML/AI SOLUTIONS!",
  skills: [
    emoji(
      "🚀 I design & scale distributed applications 💻 with Python, Java & JavaScript on the cloud☁️."
    ),
    emoji("⚙️ I build CI/CD pipelines & automate 🔄 workflows for faster, reliable deployments📦."),
    emoji(
      "🤖 I leverage AI & ML to deliver impactful📊, real-world🌍 solutions."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "R",
      fontAwesomeClassname: "fab fa-r-project"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "AngularJS",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fa fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },

    {
      skillName: "GCP",
      fontAwesomeClassname: "fa fa-cloud"
    },

    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "North Carolina State University",
      logo: require("./assets/images/ncsu.png"),
      subHeader: "Masters in Computer Science, GPA: 3.9/4.0",
      duration: "Aug 2022 - May 2024",
      desc: "Courses:",
      descBullets: [
        "Object Oriented Design & Development,Cloud Engg, Software Engg, Design & Analysis of Algorithms",
        "Database Management Concepts & Systems, Neural Networks, Experimental Statistics, Automated Learning Data Analysis, Data Science"
      ],
    },
    {
      schoolName: "University College of Engineering, Osmania University",
      logo: require("./assets/images/uceou.png"),
      subHeader: "Bachelors in Computer Science, GPA: 9.04/10",
      duration: "Aug 2015 - May 2019",
      desc: "Courses:",
      descBullets: [
        "Data Structures, Operating Systems, Web Development, Programming Languages Paradigms, Object Oriented Programming, DBMS",
        "Cloud Computing, Distributed Systems, Computer Networks, Internet Protocols, Data Science Foundations, Data Mining, Artificial Intelligence",
        // "Ranked top 5 in the class, top 10% in the university"
      ],
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming",
      progressPercentage: "100%"
    },
    {
      Stack: "ML/AI",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "100%"
    },
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "DevOps",
      progressPercentage: "80%"
    },

  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
{
  role: "Software Engineer",
  company: "Pragmatic IT Inc.",
  companylogo: require("./assets/images/pragmatic.jpeg"),
  date: "Apr 2025 - Present",
  descBullets: [
"Architected a distributed payroll automation platform with Java Spring Boot, AWS ECS, Cognito & Secrets Manager (99.95% uptime, -30% manual effort), built ingestion workflows with Lambda, Step Functions, RDS & S3 (2 hrs → 15 mins), and adopted event-driven architecture with SNS & SQS (+54% response rate).",
"Optimized PostgreSQL (-25% latency), automated reconciliation with Python (0% discrepancies), implemented AI payroll summarization with OpenAI API (-55% reporting time), built a responsive React.js & TypeScript UI (+40% performance), streamlined CI/CD with GitLab CI & CloudWatch (-37.5% deployment time, -50% recovery), deployed ECS Fargate Blue-Green microservices (0% downtime), and monitored systems with CloudWatch (-76% cloud costs)."
  ]
},
{
  role: "Software Engineer",
  company: "North Carolina State University",
  companylogo: require("./assets/images/ncsu.png"),
  date: "Sep 2023 - Apr 2025",
  descBullets: [
    "Developed ML solutions for agriculture using Python, scikit-learn & Pandas (Random Forest, +18% forecast accuracy) and optimized preprocessing with OpenCV & NumPy (+10% fidelity).",
"Built high-performance pipelines with YOLOv8, FastAPI & AWS Lambda (10× faster analysis), integrated S3 & DynamoDB for low-latency retrieval (+27% speed), and deployed secure ML inference via API Gateway & IAM-protected Lambda."
  ]
},
{
  role: "Software Engineer Intern",
  company: "US Department of Agriculture",
  companylogo: require("./assets/images/usda_logo.jpeg"),
  date: "Jun 2023 - Aug 2023",
  descBullets: [
"Developed Random Forest model with scikit-learn to predict crop yields, improving forecast accuracy by 18%, and optimized image preprocessing with OpenCV & NumPy, improving fidelity by 10%.",
"Built ML pipelines with YOLOv8, FastAPI & AWS Lambda for plant genomic stem counts (10x faster), implemented low-latency retrieval with S3 & DynamoDB (+27% speed), and deployed ML inference with API Gateway & Lambda secured by IAM for uptime & data protection."
  ]
},
{
  role: "Associate Software Developer",
  company: "Deloitte",
  companylogo: require("./assets/images/deloitte.jpeg"),
  date: "Jun 2019 - Jul 2022",
  descBullets: [
 "Engineered secure RESTful APIs with Java Spring Boot & Python FastAPI (OAuth2, JWT), containerized with Docker & Kubernetes, and integrated CI/CD (Jenkins, GitLab CI), achieving 99.9% uptime, 31% faster peak response, and reducing release cycles from 3 days to 1.5 hours.",
"Optimized large-scale data pipelines on MS SQL Server & SAP HANA (query tuning, 100+ procedure refactors) with AWS EMR, Spark & Kafka, integrated Redis caching (32% fewer DB calls), load tested with JMeter (+15% throughput), and built Tableau dashboards, cutting manual reporting by 75%."
  ]
},
{
  role: "Junior Software Developer",
  company: "Deloitte",
  companylogo: require("./assets/images/deloitte.jpeg"),
  date: "Jan 2019 - Jun 2019",
  descBullets: [
    "Built intelligent search & alerting systems using Python (Doc2vec, RabbitMQ) & Angular, improving information discovery (85% hit rate) and cutting incident response times by 22%.",
    "Refactored legacy monolith into RESTful microservices with Java Spring & Flask, deploying on AWS EC2/S3 to reduce latency (300ms → 120ms) and boost response time by 19%."
  ]
}

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "LIST OF SOME INTERESTING PROJECTS I'VE WORKED ON",
  projects: [
    {
      image: require("./assets/images/ubuntu-unity.png"),
      projectName: "Ubuntu Unity: Celebrating Black History and Pride",
      projectDesc: "Contribution to Hack_NCState x Code Black Hackathon! Developed a MERN stack app to preserve black heritage with blogs, recipes, media, articles, GPT-powered recommender. Built using React, Node.js, MongoDB, TailwindCSS, Vite, TypeScript for a responsive 1-page UI for community engagement.",
      footerLink: [
        {
          name: "Demo Video",
          url: "https://devpost.com/software/ubuntu-unity"
        }
        //  you can add extra buttons here.
      ]
    },

    {
      image: require("./assets/images/auto-anki.png"),
      projectName: "WebGPT-4 Flashcard Builder",
      projectDesc: "Developed a Dockerized flashcard app that reads documents/URLs using Langchain & OpenAI, with Flask backend, CSS/JavaScript frontend and TravisCI, Github Actions, Kubernetes for DevOps, generating 5-100 flashcards & 90% coverage.",
      footerLink: [
        {
          name: "View Readme!",
          url: "https://github.com/smarabattula/auto_anki"
        }
      ]
    },

    {
      image: require("./assets/images/blueberry.png"),
      projectName: "Blueberry Detection & Measurement",
      projectDesc: "Developed a dataset using Computer Vision & segmentation algorithms to obtain blueberry masks and built a ML model toget the diameter of each blueberry, with 95% mAP for masks & 0.72 R2 for size. ML Model will be deployed on cloud via AWS Sagemaker, with S3 (No-SQL) and RDS (SQL) serving as databases",
      footerLink: [
        {
          name: "Github Repo!",
          url: "https://github.com/smarabattula/aros-blueberry"
        }
      ]
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("🏆My Achievements And Certifications!  "),
  subtitle: "",
    // "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "IEEE Extreme 17.0 Hackathon",
      subtitle:
        "Finished 20th in USA and Top 10% Worldwide in IEEE Extreme 24 hr competitive hackathon",
      image: require("./assets/images/ieee.jpeg"),
      imageAlt: "IEEE Extreme 17.0 2023 Hackathon",
      footerLink: [
        {
          name: "IEEE Team 'Devara'",
          url: "https://csacademy.com/user/ieee_40600aabd86afb47c05492e43eca3b05c428ab4e214ebe84799d7639b5675059"
        },
      ]
    },
    {
      title: "JPMC Code for Good 2018 Hackathon Finalist",
      subtitle:
        "Finalist in JP Morgan Chase’s Code for Good Hackathon, where an end-to-end android application was delivered for a Non-Profit organization to facilitate volunteering work for their users.",
      image: require("./assets/images/jpmc.jpg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        // {
        //   // name: "",
        //   // url: "#"
        // }
      ]
    },
    {
      title: "Hack_NCState x Code Black Hackathon",
      subtitle: "Contributed to the hackathon by developing a MERN stack web app to build community for preserving black heritage",
      image: require("./assets/images/Hack_NCState_Logo.png"),
      imageAlt: "Hack_NCState x Code Black Hackathon logo",
      footerLink: [
        // {
        //   // name: "",
        //   // url: "#"
        // }
      ]
    },
    {
      title: "Certifications!",
      subtitle: "Completed certifications in Cloud Computing, Data Science, Data Mining, Machine Learning & Deep Learning courses.",
      image: require("./assets/images/certify.png"),
      imageAlt: "Certifications!",
      footerLink: [
        {
        name: "ML certificate",
        url: "https://www.coursera.org/account/accomplishments/verify/ZJHZLJDH8QUV"
        },
        {
          name: "Deep Learning certificate",
          url: "https://courses.nvidia.com/certificates/37241032c3d9499c8304c18b6e281507"
          },
        {
          name: "Cloud Certificate",
          url: "https://archive.nptel.ac.in/noc/Ecertificate/?q=noc19-cs27/NPTEL19CS27S41450586191068674.jpg"
        },
        {
          name: "Data Mining certificate",
          url: "https://drive.google.com/file/d/1hdvzGwxvOrTm05gqjrXSfebX--yo4WfC/view?usp=sharing"
        },
        {
          name: "Data Science Certificate",
          url: "https://archive.nptel.ac.in/noc/Ecertificate/?q=noc19-cs13/NPTEL19CS13S11360870191068674.jpg"
        },
      ]
    },
    {
      title: "AWS Certified",
      subtitle: "Certified in AWS Cloud Practitioner and more. Link Below!",
      image: require("./assets/images/aws.jpg"),
      imageAlt: "Certifications!",
      footerLink: [
        {
          name: "Certificate Credentials",
          url: "https://www.credly.com/badges/877b1953-8d5b-4e1e-9f89-e5d47a1c33e2/linked_in_profile"
        },
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me!"),
  subtitle:
    "Feel free to contact me on my mail and links below!",
  // number: "+92-0000000000",
  message: "Open to 2025 Job Opportunities: Yes!"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
